'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const hasBody = () => {
  return typeof document !== "undefined" && !!document.body;
};
const useUnscrollableBody = ({ shouldAllowScroll }) => {
  React.useEffect(() => {
    if (hasBody()) {
      document.body.style.overflow = shouldAllowScroll ? "" : "hidden";
    }
    return () => {
      if (hasBody()) {
        document.body.style.overflow = "";
      }
    };
  }, [shouldAllowScroll]);
};

exports.useUnscrollableBody = useUnscrollableBody;
//# sourceMappingURL=useUnscrollableBody.cjs.js.map
